import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsTHandlingLogEntryForwardEvent } from "../../../common/types/order-details-handling-log-entry-event";

const getContractDisplayNameLabel = (
  contractDisplayName: OrderDetailsTHandlingLogEntryForwardEvent["contractDisplayName"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().forwardOrderEntry
      .contractDisplayNameTemplateText;

  return translations.replace(
    "#{contractDisplayName}",
    contractDisplayName ?? "-----",
  );
};

const getContractDisplayNameTitle = (
  contractDisplayName: OrderDetailsTHandlingLogEntryForwardEvent["contractDisplayName"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().forwardOrderEntry
      .contractDisplayNameTemplateText;

  return translations.replace(
    "#{contractDisplayName}",
    contractDisplayName ?? "-----",
  );
};

const orderDetailsHistoryEntryForwardContentHelper = {
  getContractDisplayNameLabel,
  getContractDisplayNameTitle,
};

export default orderDetailsHistoryEntryForwardContentHelper;
